/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Mirroring Smartrr’s hidden selling_plan into in-form field via polling
  document.addEventListener('DOMContentLoaded', function(){
    const external = document.querySelector('input[data-smartrr-selling-plan-input]');
    const internal = document.querySelector('input[data-atc-button-selling-plan-input]');

    if (!external || !internal) {
      // console.warn('[custom.js] Missing inputs', { external, internal });
      return;
    }

    function mirror() {
      if (internal.value !== external.value) {
        internal.value = external.value;
        // console.log('[custom.js] mirrored →', internal.value);
      }
    }

    mirror();

    const poller = setInterval(mirror, 200);

    document.addEventListener('theme:cart:add', function(){
      mirror();
      // console.log('[custom.js] before cart:add →', internal.value);
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
